<template>
  <div class="card-front" :style="'background-image: url(' + card.src + ')'">
    <div class="card-text" v-if="card.title || card.subtitle">
      <div class="title" v-if="card.title">{{ card.title }}</div>
      <div class="subtitle" v-if="card.subtitle">{{ card.subtitle }}</div>
    </div>
  </div>
</template>

<script>
  import Card from '@/models/Card';


  export default {
    name: 'CardFront',
    props: {
      card: {
        type: Card,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../config/styles/settings";
  @import "../../config/styles/util";

  .card-front {
    position: relative;
    height: 100%;
    border-radius: 3px;
    border: 1px solid $blue-500;
    background-color: $blue-200;
    background-position: center;
    background-size: cover;
  }

  .card-text {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: ($gutter * 0.25);
    background: rgba($blue-500, 0.54);
    color: $white;
    text-align: center;
  }

  .title {
    width: 100%;
    font-size: 0.8rem;
  }

  .subtitle {
    width: 100%;
    font-size: 0.6rem;
  }
</style>
